import { Link } from 'react-router-dom'
import { useQuery } from '@tanstack/react-query'
import { apiClient } from '@/lib/api'
import { useAuth } from '@/stores/authStore'
import type { SkillSummary } from '@/lib/types'

export default function DashboardPage() {
  const { user, workspace } = useAuth()
  const { data: skills } = useQuery({
    queryKey: ['skills', 'dashboard'],
    queryFn: async () => (await apiClient.get<{ data: SkillSummary[] }>('/api/v1/skills')).data,
  })

  const rows = skills?.data ?? []
  const byStatus = rows.reduce<Record<string, number>>((acc, s) => {
    acc[s.status] = (acc[s.status] ?? 0) + 1
    return acc
  }, {})

  return (
    <div className="space-y-6">
      <div>
        <h1 className="text-2xl font-semibold">Welcome{user ? `, ${user.name}` : ''}</h1>
        <p className="text-sm text-neutral-600">Workspace: {workspace?.name}</p>
      </div>

      <div className="grid grid-cols-2 md:grid-cols-4 gap-4">
        {['DRAFT', 'GUARDRAILS_PENDING', 'TESTING', 'CERTIFIED'].map((s) => (
          <div key={s} className="rounded border bg-white p-4">
            <p className="text-xs uppercase tracking-wide text-neutral-500">{s.replace('_', ' ')}</p>
            <p className="text-2xl font-semibold mt-1">{byStatus[s] ?? 0}</p>
          </div>
        ))}
      </div>

      <div className="rounded border bg-white p-4">
        <div className="flex items-center justify-between mb-3">
          <h2 className="font-semibold">Recent skills</h2>
          <Link to="/skills/new" className="text-sm rounded bg-neutral-900 text-white px-3 py-1.5">
            New skill
          </Link>
        </div>
        {rows.length === 0 ? (
          <p className="text-sm text-neutral-500">No skills yet. Create your first one.</p>
        ) : (
          <ul className="divide-y">
            {rows.slice(0, 10).map((s) => (
              <li key={s.id} className="py-2 flex items-center justify-between">
                <Link to={`/skills/${s.id}`} className="text-sm text-neutral-900 hover:underline">
                  {s.name}
                </Link>
                <span className="text-xs text-neutral-500">{s.status}</span>
              </li>
            ))}
          </ul>
        )}
      </div>
    </div>
  )
}
